import { render } from "./EncuestasEstudiante.vue?vue&type=template&id=4843ca0e&scoped=true&lang=true"
import script from "./EncuestasEstudiante.vue?vue&type=script&lang=js"
export * from "./EncuestasEstudiante.vue?vue&type=script&lang=js"

import "./EncuestasEstudiante.vue?vue&type=style&index=0&id=4843ca0e&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4843ca0e"]])

export default __exports__